type SvgIconProps = {
  className?: string
}

const iconProps = {
  width: 18,
  height: 18,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true as const,
}

/** Panel left — collapse sidebar to icon rail. */
export const IconSidebarCollapse = ({ className }: SvgIconProps) => (
  <svg className={className} {...iconProps}>
    <rect width="18" height="18" x="3" y="3" rx="2" />
    <path d="M9 3v18" />
    <path d="m16 15-3-3 3-3" />
  </svg>
)

/** Panel right — expand sidebar from icon rail. */
export const IconSidebarExpand = ({ className }: SvgIconProps) => (
  <svg className={className} {...iconProps}>
    <rect width="18" height="18" x="3" y="3" rx="2" />
    <path d="M9 3v18" />
    <path d="m14 9 3 3-3 3" />
  </svg>
)

/** Edge squircle: collapse (bold chevron left). */
export const IconChevronLeft = ({ className }: SvgIconProps) => (
  <svg
    className={className}
    width={12}
    height={12}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={3}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="m15 18-6-6 6-6" />
  </svg>
)

/** Edge squircle: expand (bold chevron right). */
export const IconChevronRight = ({ className }: SvgIconProps) => (
  <svg
    className={className}
    width={12}
    height={12}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={3}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="m9 18 6-6-6-6" />
  </svg>
)
